import React, { Component, Fragment, useState, useEffect } from "react";

import { getUserContent } from "../../Features/SiteSettings/siteSettingSlice";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useDispatch } from "react-redux";


import { useCustomizeContext } from "../../context";

const Privacy = (props) => {
   let dispatch = useDispatch();



   const [userProvacyRes, setuserProvacyRes] = useState("");

   const [contentprv, setContentprv] = useState("");

   const [titleprv, setTitleprv] = useState("");
   const [privacyimg, setPrivacyimg] = useState();


   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);


   const {
      loader: {
         setLoading,
      },
      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();


   useEffect(() => {
      userContent();
   }, []);

   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
      setClassIsActive(false);
   }, []);



   const userContent = async () => {
      setLoading(true);
      let res = await dispatch(getUserContent({ type: "user" }));

      setTimeout(() => {
         if (res?.status) {
            setuserProvacyRes(res?.data);
            setTitleprv(res?.data[1]?.title);
            setContentprv(res?.data[1]?.content);
            setPrivacyimg(res?.data[1]?.image);
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);

   }


   return (
      <Fragment>
         <Header />
         <div class="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">
                     <div className="privacypage-maincnt">
                        <section class="privacy_policy_sec_1">
                           <div class="banner-privacy my-4">
                              <img src={privacyimg} style={{ width: "840px", height: "166px" }} className="aboutimg" />

                           </div>
                           <div class="pri_pol_cd">
                              <h1 dangerouslySetInnerHTML={{ __html: titleprv }}></h1>
                              <div dangerouslySetInnerHTML={{ __html: contentprv }}></div>

                           </div>
                        </section>
                     </div>
                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );

}

export default Privacy;